import { defineMessages } from '@transcend-io/internationalization';

export const globalSettingsMessages = defineMessages(
  'privacy-center.pages.ManageYourPrivacy.components.GlobalSettings.globalSettings',
  {
    loggedInMessage: {
      defaultMessage:
        'Make the following selections that apply to you in order to ' +
        'view the relevant privacy settings that can be personally configured.',
      description:
        'The description text displayed as part of "Global Settings" ' +
        'section on "Privacy Settings" page when user is logged out.',
    },
    loggedOutMessage: {
      defaultMessage:
        'Make the following selections that apply to you in order to view the relevant privacy settings ' +
        'that can be personally configured. If you already have an account with us, you can {logIn}.',
      description:
        'The description text displayed as part of "Global Settings" ' +
        'section on "Privacy Settings" page.',
    },
    logIn: {
      defaultMessage: 'log in',
      description:
        'The text displayed on the link that allows the user to log-in from the ' +
        '"Global Settings" section on "Privacy Settings" page.',
    },
    globalPreferences: {
      defaultMessage: 'Global Preferences',
      description:
        'The title text displayed for the default preference store key as part of ' +
        '"Global Settings" section on "Privacy Settings" page.',
    },
  },
);
